import { IWebApi, IWebApiTimeoutProvider, webApiBase, WebApiConfig, WebApiHttpProviderHttpSend } from './webApiBase';

export type WebApiFetchConfig = Omit<WebApiConfig, 'timeoutProvider' | 'httpProvider'> & { unauthorised?: (message?: string) => void };

export const webApiFetchHttpProviderSend: WebApiHttpProviderHttpSend = (url, requestPayload, onSuccess, onError): void => {
  const formData = new URLSearchParams();
  Object.keys(requestPayload).map((formKey) => formData.append(formKey, (requestPayload as any)[formKey]));

  fetch(url, {
    method: 'POST',
    cache: 'no-cache',
    // headers: httpSendConfig.headers,
    body: formData,
    credentials: 'include' // Needed for Dojo NTLM
  })
    .then((res) => res.json())
    .then((response) => onSuccess(response))
    .catch((error: any) => onError(error));
};

export const webApiFetchTimeoutProvider = {
  timeout: (delayMs: number, fn: (args: void) => void) => {
    setTimeout(fn, delayMs);
  }
};

const defaultUnauthorised = (response?: any) => {
  console.log(`WebApi.unauthorised ${JSON.stringify(response)}`); // eslint-disable-line no-console
};

const registeredForUnauthenticated: ((response?: any) => void)[] = [];

/**
 * Register a callback when api call returns unauthenticated
 * @param unauthenticatedFn
 * @returns
 */
export const registerWebApiFetchUnauthorised = (unauthenticatedFn: (response?: any) => void) => {
  registeredForUnauthenticated.push(unauthenticatedFn);
  return () => {
    const idx = registeredForUnauthenticated.indexOf(unauthenticatedFn);
    if (idx !== -1) {
      registeredForUnauthenticated.splice(idx, 1);
    }
  };
};

export const webApiFetchFactory = (webApiUrl: string, webApiConfig?: WebApiFetchConfig, timeoutProvider: IWebApiTimeoutProvider = webApiFetchTimeoutProvider) =>
  webApiBase({
    ...webApiConfig,
    httpProvider: {
      webApiUrl,
      unauthorised: webApiConfig?.unauthorised ?? defaultUnauthorised,
      unauthenticated: (response: any) => registeredForUnauthenticated.forEach((fn) => fn(response)),
      httpsend: webApiFetchHttpProviderSend
    },
    timeoutProvider
  });

const webApiFetchCached: Record<string, IWebApi> = {};
export const webApiFetchInit = (webApiUrl: string, webApiConfig?: WebApiFetchConfig) => {
  webApiFetchCached[webApiUrl] = webApiFetchFactory(webApiUrl, webApiConfig);
  return webApiFetchCached[webApiUrl];
};

export const webApiFetch = (webApiUrl: string) => webApiFetchCached[webApiUrl] ?? webApiFetchInit(webApiUrl);
